
import { createContext, useEffect, useReducer } from "react"
import { add_cart, checkedbox_All_false_cart, checkedbox_All_true_cart, checkedbox_false_cart, checkedbox_true_cart, deleteAll_cart, delete_cart, delete_checked_cart } from "../constants/actionTypes";

interface TypeOfTheValue {
    cart: any[],
    dispatchCart: React.Dispatch<MyActions>,
}
const INITIAL_STATE =JSON.parse(localStorage.getItem("cart") as string)||[]

export const CartContext = createContext<TypeOfTheValue>(
    {
        cart:INITIAL_STATE,
        dispatchCart: (action: { type: string }) => {},
    }
    )

interface MyActions {
    type: string;
    payload: object|any;
}
const CartReducer = (state: any, action: MyActions) => {
   const  cartArray = [...state]
    switch (action.type) {
        case add_cart:
            cartArray.push(action.payload)
            return  cartArray ;

        case delete_checked_cart:
            const newdataArray = cartArray.filter((i: any) => { return action.payload.indexOf(i) == -1 })
            return  newdataArray ;
        case delete_cart:
            const dataArray = cartArray.filter((i: any, index: any) => { return index != action.payload })
            return  dataArray ;
        case deleteAll_cart:
            return []
        case checkedbox_true_cart:
            cartArray[action.payload].checked = true
            return cartArray
        case checkedbox_false_cart:
            cartArray[action.payload].checked = false
            return cartArray
        case checkedbox_All_true_cart:
            cartArray.map((item: { checked: boolean; }) => item.checked = true)
            return cartArray
        case checkedbox_All_false_cart:
            cartArray.map((item: { checked: boolean; }) => item.checked = false)
            return cartArray
        default:
            return state
    }
}


interface ContextProps {
    children: JSX.Element | JSX.Element[]
}

export const CartContextProvider: React.FC<ContextProps> = ({  children }) => {
    const [cart, dispatchCart] = useReducer(CartReducer, INITIAL_STATE)
    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cart))
    }, [cart]
    )
    return (
        <CartContext.Provider
            value={{
                cart,
                dispatchCart
            }} >
            {children}
        </CartContext.Provider>
    )
}

